"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _Item = require("./Item");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Breadcrumbs = ({
  breadcrumbs,
  disableMobileLayout = false
}) => {
  const breadcrumbsLength = breadcrumbs.length;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (breadcrumbsLength < 1) {
    return null;
  }

  // on mobile penultimate item should be showed when there are more than 2 items
  // if there is only one item, this item should be showed
  const previousSection = breadcrumbsLength < 2 ? breadcrumbs[0] : breadcrumbs[breadcrumbsLength - 2];
  const {
    ItemLabel: lastName = '',
    Url: previousSectionUrl = ''
  } = previousSection ?? {};
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BreadcrumbsWrapperMobile, {
      disableMobileLayout: disableMobileLayout,
      "data-testid": getTestId(_constants.BREADCRUMBS_MOBILE),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledArrowLeftThin, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledLink, {
        isLast: true,
        href: previousSectionUrl,
        name: lastName,
        children: lastName
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BreadcrumbsWrapperDesktop, {
      disableMobileLayout: disableMobileLayout,
      "data-testid": getTestId(_constants.BREADCRUMBS_DESKTOP),
      children: breadcrumbs.map(({
        ItemLabel,
        Url
      }, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Item.Item, {
          url: Url,
          name: ItemLabel,
          isLast: index === breadcrumbsLength - 1,
          numberOfItems: breadcrumbs.length
        }), index !== breadcrumbsLength - 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledArrowRightThin, {})]
      }, Url))
    })]
  });
};
exports.Breadcrumbs = Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map